import * as React from "react";
import * as Rx from "rx";
import { Location, To, createBrowserHistory } from "history";
import { Loader } from "lib/components/Loader";
import style from "./style.module.css";
import { Filter } from "../Filter";
import { PostTable } from "../PostTable";
import { PageSizeLinks } from "../PageSizeLinks";
import { Pagination } from "../Pagination";
import { observer } from "mobx-react-lite";
import { useEffect, useRef, useState } from "react";
import { getStore } from "../../store";

export const List = observer(() => {
  const { list } = getStore();
  const listContainerRef = useRef<HTMLDivElement>(null);
  const [history] = useState(createBrowserHistory());
  const [ignoreLocationChange, setIgnoreLocationChange] = useState(false);

  useEffect(() => {
    if (!listContainerRef.current) {
      return;
    }
    const disposable = Rx.Observable.fromEvent(
      listContainerRef.current,
      "keydown",
    )
      .tap((e: unknown) => (e as Event).preventDefault())
      .debounce(200) // ms
      .subscribe((e: unknown) => onKeyDown(e as KeyboardEvent));
    return () => disposable.dispose();
  }, []);
  useEffect(() => {
    const checkLocation = (location: Location) => {
      if (location.hash) {
        if (location.hash != `#${list.selectedId}`) {
          const selectedId = parseInt(location.hash.slice(1), 10);
          setIgnoreLocationChange(true);
          list.selectPost(selectedId);
        }
      }
    };
    checkLocation(history.location);
    return history.listen(({ location }) => checkLocation(location));
  }, [history]);

  useEffect(() => {
    if (ignoreLocationChange) {
      setIgnoreLocationChange(false);
      return;
    }
    const to: To = { pathname: history.location.pathname };
    if (list.selectedId) {
      to.hash = `#${list.selectedId}`;
    }
    if (list.filter.searchParams) {
      to.search = list.filter.searchParams;
    }
    history.push(to);
  }, [list.selectedId, list.filter.searchParams]);

  const onKeyDown = (e: KeyboardEvent) => {
    e.preventDefault();
    const keyCode = e.key;
    switch (keyCode) {
      case "ArrowDown":
        list.selectNextPost();
        break;
      case "ArrowUp":
        list.selectPrevPost();
        break;
    }
    return false;
  };

  const renderContent = () => {
    const { perPage, totalPages, totalCount, currentPage } = list;

    const onChangePageSize = (size: number) => {
      list.perPage = size;
    };

    const onChangePage = (page: number) => {
      list.currentPage = page;
    };

    return (
      <div className={style.root}>
        <div className={style.header}>
          <Filter />
          <PageSizeLinks {...{ perPage, onChangePageSize }} />
        </div>
        <div className={style.table} ref={listContainerRef}>
          <PostTable />
        </div>
        <div className={`${style.footer} pagination`}>
          <Pagination
            {...{ totalPages, totalCount, currentPage, onChangePage }}
          />
        </div>
      </div>
    );
  };

  return <Loader show={list.isLoading}>{renderContent()}</Loader>;
});
